module.exports = ".padding {\n  padding: 30px; }\n"